import PDFRef from "PDFLib/core/objects/PDFRef";
import Stream from "PDFLib/core/streams/Stream";
import PDFDict from "PDFLib/core/objects/PDFDict";
import {DictionaryObjectItem} from "PDFLib/core/writers/JSONWriter/JSONItem/DictionaryObjectItem";
import {IndirectObjectJsonItem} from "PDFLib/core/writers/JSONWriter/JSONItem/IndirectObjectJsonItem";
import PDFStream from "PDFLib/core/objects/PDFStream";
import {PrecompiledStringJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledStringJSONItem";
import PDFArray from "PDFLib/core/objects/PDFArray";
import {ArrayJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/ArrayJSONItem";
import {PDFBool} from "PDFLib/core";
import PDFHexString from "PDFLib/core/objects/PDFHexString";
import PDFInvalidObject from "PDFLib/core/objects/PDFInvalidObject";
import PDFName from "PDFLib/core/objects/PDFName";
import PDFNull from "PDFLib/core/objects/PDFNull";
import PDFNumber from "PDFLib/core/objects/PDFNumber";
import PDFString from "PDFLib/core/objects/PDFString";
import {PrecompiledJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledJSONItem";
import {RawJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/Streams/RawJSONItem";
import {FieldJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/SubDictionaries/FieldJSONItem";

export class JSONFactory{
    public static GetItem(object:any)
    {
        if(object instanceof PDFStream)
            return new RawJSONItem(object);

        if(object instanceof PDFDict) {
            let subtype=PDFName.of("Subtype");
            if(object.has(subtype)&&object.get(subtype).toString()=='/Widget')
                return new FieldJSONItem(object);

            return new DictionaryObjectItem(object);
        }

        if(object instanceof PDFRef)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFArray)
            return new ArrayJSONItem(object);

        if(object instanceof PDFBool)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFHexString)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFInvalidObject)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFName)
            return new PrecompiledStringJSONItem(object);

        if(object == PDFNull)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFNumber)
            return new PrecompiledStringJSONItem(object);

        if(object instanceof PDFString)
            return new PrecompiledJSONItem(object);



    }
}